import React from 'react'
import Stack from '@mui/material/Stack'
import SectionForm from '../../../common/sectionForm'
import PhoneComponent from '../../../common/phoneComponent'
import useMediaQuery from '@mui/material/useMediaQuery'

interface Props {
  formik: any
}

const OtherPhonesForm = ({ formik }: Props) => {
  const isMobile = useMediaQuery('(max-width:800px)')

  return (
    <SectionForm title='Autres numéros de téléphone'>
      <Stack direction={isMobile ? 'column' : 'row'} spacing='24px' sx={{ mb: '24px', alignItems: isMobile ? 'flex-start' : 'center' }}>
        <PhoneComponent
          object={formik.values.otherPhones[0]}
          typeName='otherPhones1.type'
          phoneName='otherPhones1.phone_number'
          postName='otherPhones1.phone_number_post'
        />
      </Stack>
      <Stack direction={isMobile ? 'column' : 'row'} spacing='24px'>
        <PhoneComponent
          object={formik.values.otherPhones[1]}
          typeName='otherPhones2.type'
          phoneName='otherPhones2.phone_number'
          postName='otherPhones2.phone_number_post'
        />
      </Stack>
    </SectionForm>
  )
}

export default OtherPhonesForm
